import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Trophy } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { formatINRShort } from "@/lib/constants";

export function WinShoutout() {
  const { user } = useAuth();
  const enabled = !!user && user.role !== "dealer";
  const { data } = useQuery({
    queryKey: ["recent-wins"],
    queryFn: async () => (await api.get("/team/recent-wins")).data,
    enabled,
    refetchInterval: 60000,
    staleTime: 30000,
  });

  useEffect(() => {
    const wins = data?.wins || [];
    if (!wins.length) return;
    const last = localStorage.getItem("sc_win_seen");
    if (!last) {
      localStorage.setItem("sc_win_seen", wins[0].won_at);
      return;
    }
    const fresh = wins.filter((w) => w.won_at > last);
    if (!fresh.length) return;
    fresh.slice(0, 3).reverse().forEach((w, i) => {
      setTimeout(() => {
        toast(`${w.owner_name} just closed ${w.company || w.name}!`, {
          description: `Order Won · ${formatINRShort(w.deal_value || 0)}`,
          icon: <Trophy className="h-4 w-4 text-amber-500" />,
          duration: 9000,
        });
      }, i * 900);
    });
    localStorage.setItem("sc_win_seen", wins[0].won_at);
  }, [data]);

  return null;
}
